import { Box, Icon, InputAdornment, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import React, { useEffect, useRef, useState } from 'react'

const LeaveSearchSelection = ({
  label,
  data,
  isLoading = false,
  selectedArray,
  setSelectedArray,
  optionsArray,
  setOptionsArray,
}) => {
  const allOptions = { name: `All ${label.toLowerCase()}` }

  const inputRef = useRef(null)

  const [query, setQuery] = useState('')

  const searchOptions = (query) => {
    query = query.toLowerCase()
    const matchingResults = data.filter((dep) => dep.name.toLowerCase().includes(query))
    query === ''
      ? setOptionsArray([allOptions, ...matchingResults])
      : setOptionsArray(matchingResults)
  }

  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsFocused(false)
    }
  }

  const handleAddOption = (selected) => {
    if (selected.name === allOptions.name) {
      setIsFocused(false)
      setSelectedArray([selected])
      setOptionsArray(data)
    } else {
      const filteredArray = selectedArray.filter((dep) => dep.name !== allOptions.name)
      const updatedArray = optionsArray.filter((dep) => dep !== selected)

      setSelectedArray([...filteredArray, selected])

      const newoptionsArray = updatedArray.some((dep) => dep.name === allOptions.name)
        ? updatedArray
        : [allOptions, ...updatedArray]

      setOptionsArray(newoptionsArray)
    }
  }

  const handleRemoveSelected = (selected) => {
    const updatedArray = selectedArray.filter((i) => i !== selected)
    setSelectedArray(updatedArray)
    setOptionsArray([...optionsArray, selected])
  }

  useEffect(() => {
    // Attach a click event listener to the document to handle clicks outside the user list container
    document.addEventListener('click', handleBlur)

    return () => {
      // Remove the click event listener when the component unmounts
      document.removeEventListener('click', handleBlur)
    }
  }, [])

  useEffect(() => {
    if (!isLoading && Array.isArray(data) && optionsArray.length === 0) {
      setOptionsArray([allOptions, ...data])
    }
  }, [isLoading])

  return (
    <Box>
      {label && <Typography>{label}</Typography>}
      <Box
        ref={inputRef}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          marginTop: '8px',
        }}
      >
        {selectedArray[0]?.name === allOptions.name ? (
          <Box
            onClick={handleFocus}
            sx={{
              cursor: 'pointer',
              padding: '10px 14px',
              borderRadius: '4.5px',
              border: '1px solid #8A8A8A',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '3px',
            }}
          >
            <Typography>{allOptions.name}</Typography>
            <Icon
              sx={{
                marginRight: -1,
                color: isFocused ? 'alternate.main' : 'light-gray-text.main',
                rotate: isFocused ? '-90deg' : '90deg',
              }}
            >
              chevron_right
            </Icon>
          </Box>
        ) : (
          <AdxInput
            placeholder={isFocused ? 'Search' : 'Select'}
            value={query}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={(e) => {
              setQuery(e.target.value)
              searchOptions(e.target.value)
            }}
            startAdornment={
              isFocused && (
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              )
            }
            endAdornment={
              <InputAdornment position="end" sx={{ marginRight: -1 }}>
                <Icon
                  sx={{
                    color: isFocused && 'alternate.main',
                    rotate: isFocused ? '-90deg' : '90deg',
                  }}
                >
                  chevron_right
                </Icon>
              </InputAdornment>
            }
          />
        )}
        {isFocused && (
          <Box
            sx={{
              backgroundColor: 'white.main',
              width: '100%',
              paddingY: '12px',
              maxHeight: '40vh',
              overflowY: 'scroll',
              position: 'absolute',
              zIndex: 1,
              top: '100%',
              border: '1px solid #E5E5E5',
              boxShadow: '0px 0px 10px 4px rgba(0, 0, 0, 0.05)',
              borderRadius: '7px',
            }}
          >
            {optionsArray.length === 0 ? (
              <Box sx={{ padding: '12px 24px' }}>
                <Typography>No matching departments found.</Typography>
              </Box>
            ) : (
              optionsArray
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((i, index) => (
                  <Box
                    key={index}
                    onClick={() => handleAddOption(i)}
                    sx={{
                      padding: '12px 24px',
                      '&:hover': {
                        backgroundColor: 'gray-background.main',
                        cursor: 'pointer',
                      },
                    }}
                  >
                    <Typography>{i.name}</Typography>
                  </Box>
                ))
            )}
          </Box>
        )}
      </Box>
      {!(selectedArray[0]?.name === allOptions.name) && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: selectedArray.length !== 0 && '8px',
            gap: '8px',
          }}
        >
          {selectedArray.map((i, index) => (
            <React.Fragment key={index}>
              {i.name !== allOptions.name && (
                <Box
                  sx={{
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    backgroundColor: 'gray-background.main',
                    borderRadius: '45px',
                  }}
                >
                  <Typography>{i.name}</Typography>
                  <Icon
                    onClick={() => handleRemoveSelected(i)}
                    sx={{ color: 'error.main', fontSize: '20px', cursor: 'pointer' }}
                  >
                    close
                  </Icon>
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default LeaveSearchSelection
